<template>
  <div class="ws-modal">
    <form class="ws-modal__form" @submit.prevent="submit">
      <header class="ws-modal__header">
        <h2 class="has-text-weight-bold is-size-1">
          <span v-if="!isNewItem" v-text="$t('Редактировать экзамен')"></span>
          <span v-else v-text="$t('Создать новый экзамен')"></span>
        </h2>
      </header>
      <div class="ws-modal__content" :class="{'is-loading':isPending}">
        <div class="columns is-multiline">
          <div class="column is-12" v-if="!isNewItem">
            <b-field class="ws-field is-required"
                     :label="$t('Название экзамена')"
                     :type="{'is-danger': errors.has('name')}"
                     :message="errors.first('name')">
              <b-input class="ws-field__control"
                       v-model="newItem.name.translate.ru"
                       v-validate="{ required: true }"
                       :data-vv-as="$t('Название экзамена')"
                       name="name"
              />
            </b-field>
          </div>
          <div class="column is-8">
            <b-field class="ws-field"
                     :label="$t('Профессия/специальность (ДЭ)')"
                     :type="{'is-danger': errors.has('competence')}"
                     :message="errors.first('competence')">
              <ws-refbook-field
                entity="competence"
                field="name.display"
                name="competence"
                :guid.sync="competence.guid"
                :item.sync="competence.item"
                v-model="competence.value"
                :query="{wo_skill: true}"
                @change="selectCompetence"
                :disabled="isCompetenceDisable"
                v-validate="{ required: true, selected: competence.guid }"
                :data-vv-as="$t('Профессия/специальность (ДЭ)')"
                :isFocus="true">
                <template slot="empty" v-text="$t('Ничего не найдено')"></template>
              </ws-refbook-field>
            </b-field>
          </div>
          <div class="column is-2">
            <b-field class="ws-field"
                     :label="$t('Сложность')"
                     :type="{'is-danger': errors.has('acc')}"
                     :message="errors.first('acc')">
              <b-select class="ws-field__control"
                        :disabled="!competence.item.guid"
                        name="acc"
                        v-validate="{ required: true }"
                        v-model="newItem.accred_comps.complexity_level"
                        :data-vv-as="$t('Сложность')"
                        :placeholder="$t('')"
                        expanded>
                <option
                  v-for="level in constants.COMPEXITY_LEVELS"
                  :value="level"
                  :key="level">
                  {{ level }}
                </option>
              </b-select>
            </b-field>
          </div>
          <div class="column is-2">
            <b-field class="ws-field" :label="$t('Наличие КОД')">
              <b-input class="ws-field__control"
                       disabled
                       :value="isHasCod() ? $t('Есть') : $t('Нет')"
                       :data-vv-as="$t('Наличие КОД')"
                       :placeholder="$t('')" />
            </b-field>
          </div>
          <div class="column is-4">
            <b-field class="ws-field"
                     :label="$t('Дата проведения')"
                     :type="{'is-danger': errors.has('day_cm1')}"
                     :message="errors.first('day_cm1')">
              <ws-datepicker
                v-validate="{ required: true }"
                v-model="day_cm1"
                :data-vv-as="$t('День ПД')"
                name="day_cm1"
                @input="onSelectDaycm1"
                :focused-date="nextMonth"
                class="ws-field__control">
              </ws-datepicker>
            </b-field>
          </div>
          <div class="column is-8">
            <b-field class="ws-field"
                     :label="$t('Образовательная Организация')"
                     :type="{'is-danger': errors.has('institution')}"
                     :message="errors.first('institution')">
              <ws-refbook-field
                entity="public/refbook/education/institution"
                field="title.display"
                name="institution"
                :guid.sync="institution.guid"
                :item.sync="institution.item"
                v-model="institution.value"
                @change="selectInstitution"
                v-validate="{ required: true, selected: institution.guid }"
                :data-vv-as="$t('ОО')"
                :isFocus="true">
                <template slot="empty" v-text="$t('Ничего не найдено')"></template>
                <template
                    slot="item"
                    slot-scope="props"
                >
                  <p>
                    <ws-icon v-if="props.option.visible === false" name="stop" color="red" class="icon-stop" width="15" height="15"/>
                    {{ props.option.title.display }}
                  </p>
                </template>
              </ws-refbook-field>
            </b-field>
          </div>
          <div class="column">
            <b-field class="ws-field"
                     :label="$t('Программа обучения')"
                     :type="{'is-danger': errors.has('study_group')}"
                     :message="errors.first('study_group')">
              <ws-refbook-field
                :disabled="!institution.guid"
                entity="refbook/study_groups"
                field="name"
                name="study_group"
                :guid.sync="study_group.guid"
                :item.sync="study_group.item"
                :list.sync="study_group.list"
                v-model="study_group.value"
                :query="{education_guid: institution.guid, education_year: new Date().getFullYear()}"
                @change="selectStudyGroup"
                v-validate="{ required: true }"
                :data-vv-as="$t('Программа обучения')"
                :isFocus="true">
                <template slot="empty" v-text="$t('Ничего не найдено')"></template>
              </ws-refbook-field>
            </b-field>
          </div>
          <div class="column is-12">
            <p v-text="$t('Импорт участников')"></p>
            <b-field v-if="users.length === 0" class="ws-field">
              <ws-participants-import
                format="xlsx"
                name="users"
                @input-users="onImportUsers"></ws-participants-import>
            </b-field>
            <div v-else>
              Импортировано {{users.length}} Участников
            </div>
          </div>
        </div>
      </div>
      <footer class="ws-modal__footer">
        <div class="columns">
          <div class="column is-8"></div>
          <div class="column is-4 is-vcentered">
            <div class="has-text-right-desktop">
              <button class="ws-button button is-large is-primary is-fullwidth" :class="{'is-loading':isPending}">
                <span class="is-size-4 has-text-weight-bold" v-if="!isNewItem" v-text="$t('Редактировать')"></span>
                <span class="is-size-4 has-text-weight-bold" v-else v-text="$t('Создать')"></span>
              </button>
            </div>
          </div>
        </div>
      </footer>
    </form>
    <aside class="ws-modal__sidebar">
      <button class="ws-button button is-text"
              @click="close">
        <ws-icon
          class="ws-button__icon"
          name="close-thin"
          color="#000000"
          :fill="true"
          :title="$t('Закрыть')"
          width="17"
          height="18"
        />
      </button>
    </aside>
  </div>
</template>

<script>
import WsDatepicker from '@/components/common/WsDatepicker'
export default {
  name: 'WsExamsFilterModal',
  components: { WsDatepicker },
  props: {
    item: {
      type: Object,
      default: () => {
        return {
        }
      }
    }
  },
  data () {
    return {
    }
  },
  watch: {
  },
  computed: {
  },
  mounted () {
  },
  methods: {
    close () {
      this.$parent.close()
    }
  }
}
</script>
